module.exports = __webpack_public_path__ + "static/media/A1-31-Tetrak-cod139.d091153f.png";